// src/components/Loader.js
import React from 'react';

const Loader = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: '#ffffff',
      zIndex: 9999,
      flexDirection: 'column'
    }}>
      {/* Spinner Animation */}
      <div style={{
        width: '50px',
        height: '50px',
        border: '5px solid #f3f3f3',
        borderTop: '5px solid #3498db',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      
      {/* Loading Text */}
      <div style={{
        marginTop: '20px',
        fontSize: '18px',
        color: '#333',
        fontFamily: 'Arial, sans-serif'
      }}>
        Loading HaiderSoftwares...
      </div>
    </div>
  );
};

export default Loader;